export default {
  PRIVATE: 1, // Particulier
  BUSINESS: 9, // Zakelijke relatie
  LEAD: 12, // Lead
  MORTGAGE_LEAD: 13, // Hypotheek lead
  INSURANCE_LEAD: 14, // Verzekerings lead
  PROSPECT: 5, // Prospect
  BUSINESS_PROSPECT: 10, // Prospect Zakelijk
  MORTGAGE_RELATION: 4, // Hypotheek relatie
  INSURANCE_RELATION: 8, // Verzekeringsrelatie

  TOTAL: 6, // Totaalklant
  EXPIRING: 2, // Aflopend
  EXPIRED: 7, // Vervallen
  BUSINESS_EXPIRED: 11, // Zakelijk vervallen
};
